module.exports = __webpack_public_path__ + "static/media/SofiaProSemiBold.2d29af1e.eot";